export const coloresPorLetra = {
  A: "#7C025A",
  B: "#C03028",
  C: "#A890F0",
  D: "#A040A0",
  E: "#E0C068",
  F: "#5E1675",
  G: "#B8A038",
  H: "#DAA74D",
  I: "#705898",
  J: "#850360",
  K: "#FA6C6C",
  L: "#6890F0",
  M: "#48CFB2",
  N: "#FFCE4B",
  O: "#F85888",
  P: "#98D8D8",
  Q: "#7038F8",
  R: "#190385",
  S: "#EE99AC",
  T: "#036885",
  U: "#29C8FF",
  V: "#FF3333",
  W: "#FF204E",
  X: "#1640D6",
  Y: "#7752FE",
  Z: "#036885",
};


const USER_COLOR_RANDOM = {
  A: "#0EE271",
  B: "#C03028",
  C: "#A890F0",
  D: "#A040A0",
  E: "#E0C068",
  F: "#5E1675",
  G: "#B8A038",
  H: "#A8B820",
  I: "#705898",
  J: "#B8B8D0",
  K: "#FA6C6C",
  L: "#6890F0",
  M: "#48CFB2",
  N: "#FFCE4B",
  O: "#F85888",
  P: "#98D8D8",
  Q: "#7038F8",
  R: "#705848",
  S: "#EE99AC",
  T: "#79F113",
  U: "#29C8FF",
  V: "#FF3333",
  W: "#FF204E",
  X: "#1640D6",
  Y: "#7752FE",
  Z: "#87A922",
};